import React, { useState } from "react";
import "./port3.css";

const Desktop3 = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(null);

  const handleButtonClick = (year) => {
    setSelectedYear(year);
    setHoveredImage(null);
  };

  const handleImageHover = (imageKey) => {
    setHoveredImage(imageKey);
  };

  const handleImageLeave = () => {
    setHoveredImage(null);
  };
  return (
    <div className="desktop-3g">
      <div className="wearemember">
        <hi className="wearemember1">
          We are a member of
        </hi>
        <img className="startupimg3" src="/CII_LOGO.png"></img>
        <div className="wearemember1">
          <hi className="recog">
            Recognized by
          </hi>

        </div>
        <img className="startupimg" src="/vreonstartup india.png"></img>

        <div className="wearemember">


        </div>
        <img className="startupimg1" src="/Xticlogo1.png"></img>
      </div>

      <div className="others">

        <div className="awardsandrecognition">
          <b className="awardsg">Awards</b>
          <b className="recognitiong">Recognition</b>
          <div className="andg">and</div>
        </div>

        <b className="testimonialg">Testimonial</b>

        <img className="image-1-icong" alt="" src="/timeportflio.png" />
        <div className="those-magazine-dieting-stories-parentg">
          <b className="those-magazine-dietingg">
            “VREON Tech quickly delivered a quality solution. They showed
            strong customer service skills, communicating responsively and providing
            updates throughout the process. Overall the team was timely, helpful, and committed to the project.”
          </b>
          <b className="mr-padmanabhang">
            Mr. Padmanabhan, Founder, Ankidyne
          </b>
          <div className="desktop-3-itemg" />
          <div className="desktop-3-item1g" />
          <div className="desktop-3-item2g" />
          <div className="desktop-3-item3g" />
          <div className="desktop-3-item4g" />
        </div>
        <div className="any-physician-who-advertises-a-parentg">
          <b className="any-physician-whog">
            “VREON Tech's commitment to quality and client satisfaction is evident in every project.
            With them, you're not just getting a service; you're getting a promise of reliability and innovation.”
          </b>
          <b className="dr-j-jeyakanthang">
            Dr. J. Jeyakanthan, Dean, Faculty of Science,Alagappa University.
          </b>
          <div className="desktop-3-itemg" />
          <div className="desktop-3-item1g" />
          <div className="desktop-3-item2g" />
          <div className="desktop-3-item3g" />
          <div className="desktop-3-item4g" />
        </div>
        <div className="the-vr-parentg">
          <b className="the-vrg">
            “The VR explanation of point-of-sale operations given by VREON Tech
            is a standout. It turns what could be a complex process into a
            user-friendly and immersive experience.”
          </b>
          <b className="mr-k-rg">
            Mr. K.R. Ilanghovan, Chairman and Managing Director of Oasys Cybernetics
          </b>
          <div className="desktop-3-itemg" />
          <div className="desktop-3-item1g" />
          <div className="desktop-3-item2g" />
          <div className="desktop-3-item3g" />
          <div className="desktop-3-item4g" />
        </div>
        <div className="clients-arent-parentg">
          <b className="clients-arentg">
            “Clients aren't just transactions for VREON; they're relationships built on trust and
            shared success. Their personalised approach makes you feel like a valued partner rather
            than just a customer”
          </b>
          <b className="thiru-dindigulg">
            Thiru. Dindigul I.Leoni, Chairman, Tamilnadu Textbook and Educational Services Corporation.
          </b>
          <div className="desktop-3-itemg" />
          <div className="desktop-3-item1g" />
          <div className="desktop-3-item2g" />
          <div className="desktop-3-item3g" />
          <div className="desktop-3-item4g" />
        </div>

        <div className="desktop-3-childg">
          <b className="ask-your-loyalg">
            “The Virtual Reality experience given by VREON Tech has captivated our students,
            making complex subjects engaging and memorable. The technical support has been impressive
            and I'm looking forward to engaging with the team in the upcoming times.”
          </b>
          <b className="ca-dr-pannaig">
            CA. Dr. Pannai M. Karthikeyan, Chairman, Pannai Group of Institutions
          </b>
          <div className="desktop-3-itemg" />
          <div className="desktop-3-item1g" />
          <div className="desktop-3-item2g" />
          <div className="desktop-3-item3g" />
          <div className="desktop-3-item4g" />
        </div>
        <div id="year2020" className={`desktop-3-innerg ${selectedYear === 2020 ? 'active' : ''}`} />
        <div id="year2019" className={`desktop-3-innerg ${selectedYear === 2019 ? 'active' : ''}`} />
        <div id="year2018" className={`desktop-3-innerg ${selectedYear === 2018 ? 'active' : ''}`} />

        <a
          className={`bg ${selectedYear === 2020 ? 'active' : ''}`}
          onClick={() => handleButtonClick(2020)}
          href="#year2020"
        >
          2023
        </a>
        <a
          className={`b1g ${selectedYear === 2019 ? 'active' : ''}`}
          onClick={() => handleButtonClick(2019)}
          href="#year2019"
        >
          2023
        </a>
        <a
          className={`b2g ${selectedYear === 2018 ? 'active' : ''}`}
          onClick={() => handleButtonClick(2018)}
          href="#year2018"
        >
          2020
        </a>
        <div className="desktop-3-innerg" />
        <div className="line-divg" />

        <div className="ellipse-divg" />
        <div className="desktop-3-child1g" />
        <div className="desktop-3-child2g" />

        <div className="arrow-icong" />
        <div className="desktop-3-child3g" />
        <div className="desktop-3-child4g" />

        <div className="horizontal-line1g" />
        <div className="horizontal-line2g" />
        <div className="horizontal-line3g" />
        {selectedYear && (
          <div>
            {/* Display images based on the selected year */}
            {selectedYear === 2020 && (
              <>
                {/* Add your images for 2020 with individual hover handling */}
                <img
                  className={`zoom-image zoom-image1 ${hoveredImage === "zoom-image1" ? "hovered" : ""}`}
                  alt=""
                  src="/annacertificate_page.jpg"
                  onMouseEnter={() => handleImageHover("zoom-image1")}
                  onMouseLeave={handleImageLeave}
                />
                {/* <img
                className={`zoom-image zoom-image2 ${hoveredImage === "zoom-image2" ? "hovered" : ""}`}
                alt=""
                src="/annacertificate_page.jpg"
                onMouseEnter={() => handleImageHover("zoom-image2")}
                onMouseLeave={handleImageLeave}
              />
              <img
                className={`zoom-image zoom-image3 ${hoveredImage === "zoom-image3" ? "hovered" : ""}`}
                alt=""
                src="/annacertificate_page.jpg"
                onMouseEnter={() => handleImageHover("zoom-image3")}
                onMouseLeave={handleImageLeave}
              /> */}
              </>
            )}
            {selectedYear === 2019 && (
              <>
                {/* Add your images for 2019 */}
                <img
                  className={`zoom-image zoom-image4 ${hoveredImage === "zoom-image4" ? "hovered" : ""}`}
                  alt=""
                  src="/geneiscertificate.png"
                  onMouseEnter={() => handleImageHover("zoom-image4")}
                  onMouseLeave={handleImageLeave}
                />
                {/* <img
                className={`zoom-image zoom-image5 ${hoveredImage === "zoom-image5" ? "hovered" : ""}`}
                alt=""
                src="/geneiscertificate.png"
                onMouseEnter={() => handleImageHover("zoom-image5")}
                onMouseLeave={handleImageLeave}
              />
              <img
                className={`zoom-image zoom-image6 ${hoveredImage === "zoom-image6" ? "hovered" : ""}`}
                alt=""
                src="/geneiscertificate.png"
                onMouseEnter={() => handleImageHover("zoom-image6")}
                onMouseLeave={handleImageLeave}
              /> */}
              </>
            )}
            {selectedYear === 2018 && (
              <>
                {/* Add your images for 2018 */}
                <img
                  className={`zoom-image zoom-image7 ${hoveredImage === "zoom-image7" ? "hovered" : ""}`}
                  alt=""
                  src="/finalistcertificate.png"
                  onMouseEnter={() => handleImageHover("zoom-image7")}
                  onMouseLeave={handleImageLeave}
                />
                {/* <img
                className={`zoom-image zoom-image8 ${hoveredImage === "zoom-image8" ? "hovered" : ""}`}
                alt=""
                src="/finalistcertificate.png"
                onMouseEnter={() => handleImageHover("zoom-image8")}
                onMouseLeave={handleImageLeave}
              />
              <img
                className={`zoom-image zoom-image9 ${hoveredImage === "zoom-image9" ? "hovered" : ""}`}
                alt=""
                src="/finalistcertificate.png"
                onMouseEnter={() => handleImageHover("zoom-image9")}
                onMouseLeave={handleImageLeave}
              /> */}
              </>
            )}

          </div>
        )}


      </div>
    </div>
  );
};

export default Desktop3;
